import React, { FC } from 'react'
import { StyledUserIcons } from '..'
import UserDenea from '../../Auth/Marketing/Testimonials/Images/denea-marable.jpeg'
import UserSusannah from '../../Auth/Marketing/Testimonials/Images/susannah-zawko.jpg'
import UserSue from '../../Auth/Marketing/Testimonials/Images/sue.jpg'
import UserMarc from '../../Auth/Marketing/Testimonials/Images/marc-bates.jpg'

const UserIcons: FC = () => {
  return (
    <StyledUserIcons>
      <img src={UserDenea} className="user-bubble first-img" />
      <img src={UserSusannah} className="user-bubble second-img" />
      <img src={UserSue} className="user-bubble third-img" />
      <img src={UserMarc} className="user-bubble fourth-img" />
      <p className="cta">Join our community of over 10k business owners</p>
    </StyledUserIcons>
  )
}

export default UserIcons
